/* eslint-disable @typescript-eslint/ban-ts-comment */
import fillTemplate from "es6-dynamic-template";

import {
  australiaResource,
  canadaResource,
  commonResource,
  newZealandResource,
  unitedKingdomResource,
  unitedStatesResource,
} from "../resources";

import { CountryList } from "./../lib/apt-merchant/src/types/base";

type CountryListResourceTypeMap = {
  [key in CountryList]: any;
};

const countryResourceMap: CountryListResourceTypeMap = {
  "United States": unitedStatesResource,
  Australia: australiaResource,
  Canada: canadaResource,
  "New Zealand": newZealandResource,
  "United Kingdom": unitedKingdomResource,
};

export type Translate = (key: string | undefined, variables?: any) => string;

export function getIntl(
  c: CountryList | undefined,
  useDefault: string[] = []
): Translate {
  return (key = "", variables?: any) => {
    if (c) {
      try {
        // if key is specified in useDefault, skip key to use default translation
        if (!useDefault.includes(key)) {
          const result = countryResourceMap[c][key];
          if (result) {
            return fillTemplate(result, variables);
          }
        }
      } catch (_) {
        // TODO: log to sentry
        // ignore
        console.warn(`getIntlString undefined | Key: ${key} | Country: ${c}`);
      }
    }
    // @ts-ignore
    return fillTemplate(commonResource[key] ?? "", variables);
  };
}
